import gsap from "gsap";
import CLASSES from "./utils/class";
import { ANIMATION, animateObserver, fadeIn, parallaxVerticalImages } from "../../../js/animations/animations";
import { isAuthor, isMobile } from "../../../js/utils";

(() => {
  "use strict";

  const BRHCompositionRestaurant = () => {
    const init = () => {
      //== Animations
      if (!isAuthor() && !isMobile()) {
        const twoBlocks = document.querySelectorAll(CLASSES.layout.twoBlocks);
        if (twoBlocks.length > 0) {
          twoBlocks?.forEach((element) => {
            const timeline = gsap.timeline({
              scrollTrigger: {
                trigger: element,
                toggleActions: "none none none none",
                start: "top center",
                end: "bottom top",
                scrub: true,
              },
            });

            const cards = element.querySelectorAll(ANIMATION.selectors.parallaxVerticalInnerImages);
            cards.forEach((card) => {
              const image = card.querySelector(".cmp-image__image");
              image && timeline.add(parallaxVerticalImages({ classElement: image, startsY: -20, endsY: 200 }), 0);
            });

            const appearances = gsap.timeline();
            const paragraph = element.querySelectorAll(ANIMATION.selectors.animatedParagraph);
            paragraph.length > 0 && appearances.add(fadeIn({ classElement: paragraph, duration: 2 }), 0);

            appearances.duration(2);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
        const oneBlockSmall = document.querySelectorAll(CLASSES.layout.oneBlockSmall);
        if (oneBlockSmall.length > 0) {
          oneBlockSmall?.forEach((element) => {
            const appearances = gsap.timeline();
            const paragraph = element.querySelectorAll(ANIMATION.selectors.animatedParagraph);
            paragraph.length > 0 && appearances.add(fadeIn({ classElement: paragraph, duration: 2 }), 0);
            appearances.duration(2);
            appearances.pause();
            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
        const oneBlockBig = document.querySelectorAll(CLASSES.layout.oneBlockBig);
        if (oneBlockBig.length > 0) {
          oneBlockBig?.forEach((element) => {
            const appearances = gsap.timeline();
            const decorativeTitle = element.querySelectorAll(".brh-title__text--decorative");
            decorativeTitle.length > 0 && appearances.add(fadeIn({ classElement: decorativeTitle, duration: 2 }), 0);
            const paragraph = element.querySelectorAll(ANIMATION.selectors.animatedParagraph);
            paragraph.length > 0 && appearances.add(fadeIn({ classElement: paragraph, duration: 2 }), 0);

            appearances.duration(2);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };

    init();
  };

  document.addEventListener("DOMContentLoaded", BRHCompositionRestaurant);
})();
